function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.41667 40.9163H33.5833C35.8812 40.9163 37.75 39.085 37.75 36.833V8.24968C37.75 5.99772 35.8812 4.16634 33.5833 4.16634H29.4167V0.0830078H25.25V4.16634H12.75V0.0830078H8.58333V4.16634H4.41667C2.11875 4.16634 0.25 5.99772 0.25 8.24968V36.833C0.25 39.085 2.11875 40.9163 4.41667 40.9163ZM14.4146 36.8065H10.6667V33.1335L21.0354 22.9864L24.7833 26.6594L14.4146 36.8065ZM26.5479 24.9301L22.8 21.2571L25.6583 18.458L29.4062 22.131L26.5479 24.9301ZM4.41667 10.2913H33.5833V14.3747H4.41667V10.2913Z",
  fill: "currentColor"
});

function SvgFoundedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    color: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundedIcon);
export default __webpack_public_path__ + "static/media/foundedIcon.21ba8ae0.svg";
export { ForwardRef as ReactComponent };